export class UserMaxBidsDto{
  userId?: string;
  userName? :string;
  auctionId?: string;
  bucketSize?: number;
  emailId? : string;
}
